import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import * as AuthActions from './auth.actions';

@Injectable()
export class AuthEffects {
  private readonly actions$ = inject(Actions);
  private readonly authService = inject(AuthService);

  updateProfile$ = createEffect(() => this.actions$.pipe(
    ofType(AuthActions.updateProfile),
    exhaustMap(({ dto }) => this.authService.updateProfile(dto).pipe(
      map((profile) => AuthActions.updateProfileSuccess({ profile })),
      catchError((error) => of(AuthActions.updateProfileFailure({ error }))),
    )),
  ));

  deleteAccount$ = createEffect(() => this.actions$.pipe(
    ofType(AuthActions.deleteAccount),
    exhaustMap(() => this.authService.deleteAccount().pipe(
      map(() => AuthActions.deleteAccountSuccess()),
      catchError((error) => of(AuthActions.deleteAccountFailure({ error }))),
    )),
  ));
}
